"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGatewayTrustedDeviceAnalysis extends new_item_1.default {
    constructor(newGatewayTrustedDeviceAnalysis) {
        super();
        this.sku = newGatewayTrustedDeviceAnalysis.sku;
    }
}
exports.default = NewGatewayTrustedDeviceAnalysis;
//# sourceMappingURL=new-gatewayTrustedDeviceAnalysis.js.map